<template>
    <div>
        <router-view />
    </div>
</template>
<script>
import { searchParamsKey } from "@/utils/variable";
import { login } from "@/api/login";
import { msUserInfo, channelKey } from "@/utils/variable";

export default {
    watch: {
        "route":{
            handler(newV){
                console.log(newV);
            },
            deep: true
        }
        // "$route.query.reqData": {
        //     handler(newV) {
        //         console.log("updateRoute");
        //         if (newV) {
        //             login({ reqData: newV }).then(res => {
        //                 if (res.code === 200) {
        //                     localStorage[msUserInfo] = JSON.stringify(res.data);
        //                 }
        //             });
        //         }
        //     },
        //     deep: true,
        //     immediate: true,
        // },
    },
    created() {
        let channel = this.$getParam("channel");
        localStorage[channelKey] = channel;
    },
};
</script>

<style lang="scss" scoped>
.loadingOuter {
    top: 0;
    background-color: #fff;
    height: 100vh;
    width: 100vw;
    .loading {
        margin-top: 30vw;
        width: 100vw;
        height: 48vw;
    }
}
</style>
